import React, { useContext, useMemo } from "react";
import { Address } from "../../../../../infrastructure/http/modules/cart/cart.models";
import CheckUtils from "../../../../../utilities/check-utils";
import Select from "../../../../common/select";
import IUserContext from "../../../../../infrastructure/context/user/user.context.interface";
import UserContext from "../../../../../infrastructure/context/user/user.context";

type AddressSelectDropdownProps = {
  idPrefix: string;
  selectedAddressId: string;
  newAddressId: string;
  selectAddressText: string;
  newAddressText: string;
  onSelectionChange: (
    selectedAddressId: string,
    addressList: Address[]
  ) => void;
};

const AddressSelectDropdown: React.FC<AddressSelectDropdownProps> = ({
  idPrefix,
  selectedAddressId,
  newAddressId,
  selectAddressText,
  newAddressText,
  onSelectionChange,
}) => {
  const userContext = useContext<IUserContext>(UserContext);
  const { userProfile } = userContext.user;

  const addressList = useMemo((): Address[] => {
    const { addressBook, email } = userProfile || {};
    let result = [] as Address[];

    if(!addressBook) {
      return result;
    }

    addressBook.forEach((userAddress) => {
        result.push({
          id: userAddress.id,
          firstName: userAddress.firstName,
          middleName:
            userAddress.middleName === null ||
            userAddress.middleName === undefined
              ? ""
              : userAddress.middleName,
          lastName: userAddress.lastName,
          email: email === undefined ? "" : email,
          company: userAddress.company,
          addressApiText: '',
          addressLine1: userAddress.streetAddress1,
          addressLine2:
            userAddress.streetAddress2 === null ||
            userAddress.streetAddress2 === undefined
              ? ""
              : userAddress.streetAddress2,
          postalCode: userAddress.postalCode,
          city: userAddress.city,
          phoneNumber: userAddress.telephone,
          countryCode: userAddress.country,
          county: userAddress.county
        });
      });
  
      return result;

  }, [userProfile]);


  const getAddressString = (address: Address) => {
    const userData = [address.firstName, address.middleName, address.lastName]
      .filter(Boolean)
      .join(" ");
    const addressData = [address.addressLine1, address.addressLine2]
      .filter(Boolean)
      .join(" ");
    return [
      userData,
      addressData,
      address.city,
      address.postalCode,
      address.countryCode,
    ]
      .filter(Boolean)
      .join(", ");
  };

  if (!addressList || CheckUtils.isNullOrEmptyArray(addressList)) {
    return null;
  }

  const id = idPrefix + "address_select";
  let options = addressList.map((address) => ({
    valueAttribute: address.id,
    valueTranslated: getAddressString(address),
  }));
  options.push({
    valueAttribute: newAddressId,
    valueTranslated: newAddressText,
  });

  return (
    <>
      <p>{selectAddressText}</p>
      <Select
        displayLabel={false}
        name={id}
        id={id}
        isRequired={true}
        additionalClassName="address-select"
        options={options}
        selectedOption={selectedAddressId}
        onSelectionChange={(value) => {
          onSelectionChange(value, addressList);
        }}
      />
    </>
  );
};

export default AddressSelectDropdown;
